import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getPolicyCanSeeNormalPrices, getPolicyCanSeeRetailPrices } from "@store/Store/Context/ContextSelectors";
import StoreApplicationState, { getStoreApplicationState } from "@store/Store/StoreApplicationState";
import { RetailModeSettingsModel } from "@store/Types/RetailModeSettings";

const storage = {
    isRetailModeOn: "isRetailModeOn",
};

export const updateRetailModeSettingsApiResult = (apiResult: RetailModeSettingsModel) => {
    apiResult.pricingTiers.forEach((pricingTier, index) => {
        if (!pricingTier.id) {
            pricingTier.id = index;
        }
    });
};

export const getRetailModeForced = (state: ApplicationState | StoreApplicationState) => {
    return !getPolicyCanSeeNormalPrices(state) && getPolicyCanSeeRetailPrices(state);
};

export const getRetailModeOn = (state: ApplicationState | StoreApplicationState) => {
    const _state = getStoreApplicationState(state);
    const isRetailModeActive = getRetailModeActive(state);

    if (getRetailModeForced(state)) {
        return isRetailModeActive;
    }

    const storedValue =
        typeof localStorage === "undefined" ? false : localStorage.getItem(storage.isRetailModeOn) === "true";

    return isRetailModeActive && (_state.store.data.retailMode.isRetailModeOn || storedValue);
};

export const getRetailModeActive = (state: ApplicationState | StoreApplicationState) => {
    const _state = getStoreApplicationState(state);

    return _state.store.data.retailMode.activated && getPolicyCanSeeRetailPrices(state);
};

export const setRetailModeOn = (value: boolean) => {
    return localStorage.setItem(storage.isRetailModeOn, value.toString());
};
